// extracted by mini-css-extract-plugin
module.exports = {"aggregation":"style__aggregation__zkR0q","conditions":"style__conditions__xU9Q9","delete":"style__delete__eeGkG"};